import React from 'react';
import {
  ReturnFormActions,
  ReturnItemImage,
} from '../../../Reducers/ReturnForm.reducer';
import Icon from '../../Icon';
import { useDispatch } from 'react-redux';

const ReturnFormMediaItem = ({
  item,
  id,
}: {
  item: ReturnItemImage;
  id: string;
}) => {
  const { name, fileSize } = item;
  const dispatch = useDispatch();
  return (
    <div className="col-span-full flex items-center justify-between rounded border border-gray-200 bg-white p-4">
      <p className="text-md font-medium leading-4 text-gray-700">{name}</p>
      <span className="flex gap-3">
        <p className="text-md font-light leading-4 text-gray-700">
          {fileSize}
        </p>
        <Icon
          name="close"
          className="h-4 w-4 cursor-pointer"
          onClick={() => {
            dispatch(
              ReturnFormActions.removeReturnItemImage({
                id: id,
                systemId: item.systemId,
              })
            );
          }}
        />
      </span>
    </div>
  );
};

export default ReturnFormMediaItem;
